import '@babel/polyfill';
import 'url-polyfill';
import { polyfill } from 'es6-promise';
polyfill();
import 'isomorphic-fetch';

import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';

(function() {
    if (!window.CognitoRegion || !window.CognitoUserPoolId || !window.CognitoClientIdPlayfootball || !window.CRMHost) {
        console.warn('CognitoRegion, CognitoUserPoolId, CognitoClientIdPlayfootball, CRMHost is required');
        return;
    }

	if (!window.CognitoSignOutImageURIs) {
		window.CognitoSignOutImageURIs = [];
	}

	if (localStorage.ffaClientId) {
		window.CognitoClientIdPlayfootball = localStorage.ffaClientId;
	}

    new Vue({
        el: '#app',
        template: '<App/>',
        components: { App },
        store,
        router
    });
})();
